var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"host-headline text-color",style:(_vm.borderStyle)},[_c('span',{staticClass:"border-color"},[_vm._v(_vm._s(_vm.main))]),_c('small',[_vm._v(_vm._s(_vm.sub))])])}
var staticRenderFns = []

export { render, staticRenderFns }